import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAppStartedPayload, IEvent } from './types';
import { parentRefresh } from './utils';

export interface IAppState {
  events: IEvent[];
  loading: boolean;
  filter?: string;
  presenterFilter?: string;
  sortOrder: 'newest' | 'oldest';
  categories: string[];
  filteredEvents: IEvent[];
}

export const initialState: IAppState = {
  loading: true,
  events: [],
  categories: [],
  filteredEvents: [],
  sortOrder: 'newest',
};

export const statePropName = 'app';

const appSlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    startApp: (state: IAppState) => {
      state.loading = true;
      state.events = [];
      state.categories = [];
      state.filteredEvents = [];
    },
    started: (state: IAppState, action: PayloadAction<IAppStartedPayload>) => {
      state.loading = false;
      state.events = action.payload.events;
      state.categories = action.payload.categories;
      state.filteredEvents = action.payload.filteredEvents;
      parentRefresh();
    },
    filterChanged: (state: IAppState, action: PayloadAction<string | undefined>) => {
      state.filter = action.payload;
      parentRefresh();
    },
    presenterFilterChanged: (state: IAppState, action: PayloadAction<string | undefined>) => {
      state.presenterFilter = action.payload;
      parentRefresh();
    },
    setCategories: (state: IAppState, action: PayloadAction<string[]>) => {
      state.categories = action.payload;
      parentRefresh();
    },
    setFilteredEvents: (state: IAppState, action: PayloadAction<IEvent[]>) => {
      state.filteredEvents = action.payload;
      parentRefresh();
    },
    sortOrderChanged: (state: IAppState, action: PayloadAction<'newest' | 'oldest'>) => {
      state.sortOrder = action.payload;
      parentRefresh();
    },
  },
});

export const AppActions = appSlice.actions;
export default appSlice.reducer;
